import './Sidebar.scss';
import { TipLogo } from '../../assets/icons';
import { links } from '../../shared/dataLinks';
import { Link } from './components';
import { PremiumImg } from '../../assets/images';
import { useState } from 'react';
import { Modal } from '../';
import { Contact } from '../../views/Property/components';
import { useAuthContext } from '../../hooks';

const Sidebar = () => {
  const [showContactModal, setShowContactModal] = useState(false);
  const { user } = useAuthContext();

  return (
    <div className="sidebar">
      {showContactModal && (
        <Modal toggleShow={() => setShowContactModal(false)} isContact={true}>
          <Contact txt="To become a prime member, get early access to special projects and more... please contact one of our advisors." />
        </Modal>
      )}
      <div className="sidebar__logo">
        <TipLogo />
      </div>
      <ul className="sidebar__links">
        {links.map((link) =>
          user
            ? link.id < 6 && <Link key={link.id} {...link} />
            : !link.isProtected && <Link key={link.id} {...link} />
        )}
      </ul>
      <div className="sidebar__premium">
        <PremiumImg />
        <div className="btn-container">
          <button
            className="btn small"
            onClick={() => setShowContactModal(true)}
          >
            Premium
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
